import { IntentHeadline, IntentListItem, NlpIntent } from '@feedyou/schema'

export const isHeadline = (listItem: IntentListItem): listItem is IntentHeadline => {
  return listItem.type === 'headline'
}

export const isIntent = (listItem: IntentListItem): listItem is NlpIntent => {
  // For historical reasons, intents do not have a type property.
  return listItem.type === undefined
}

export const sortIntentsAlphabetically = (intents: NlpIntent[]) => {
  return [...intents].sort((intent1, intent2) => {
    const name1 = intent1.name || intent1.id
    const name2 = intent2.name || intent2.id

    return name1.localeCompare(name2)
  })
}
